module.exports = __webpack_public_path__ + "static/media/computer-speaker.92d47255.svg";